// 海康-摄像头组件

import React, { useState, useEffect } from 'react'
import './HaiKangVideo.scss';

export default ({ playURL, id, styleMedia }) => {

  const [player, setPlayer] = useState(null);

  useEffect(() => {
    if (playURL) { createPlayer(); }
  }, []);

  useEffect(() => {
    player && realplay();
  }, [player]);

  const createPlayer = () => {
    let player = new window.JSPlugin({
      szId: id ? id : 'playerHangkang',
      szBasePath: "../../../../../public/static",
      iMaxSplit: 1,
      iCurrentSplit: 1,
      openDebug: true,
      oStyle: {
        borderSelect: '#000',
      }
    })

    // 事件回调绑定
    player.JS_SetWindowControlCallback({
      windowEventSelect: function (iWndIndex) {  //插件选中窗口回调
        console.log('插件选中窗口 callback: ', iWndIndex);
      },
      pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {  //插件错误回调
        console.log('插件错误 callback: ', iWndIndex, iErrorCode, oError);
      },
      windowEventOver: function (iWndIndex) {  //鼠标移过回调
        //console.log(iWndIndex);
      },
      windowEventOut: function (iWndIndex) {  //鼠标移出回调
        //console.log(iWndIndex);
      },
      windowEventUp: function (iWndIndex) {  //鼠标mouseup事件回调
        //console.log(iWndIndex);
      },
      windowFullCcreenChange: function (bFull) {  //全屏切换回调
        console.log('全屏切换 callback: ', bFull);
      },
      firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {  //首帧显示回调
        console.log('首帧显示 loaded callback: ', iWndIndex, iWidth, iHeight);
      },
      performanceLack: function () {  //性能不足回调
        console.log('性能不足 callback: ');
      }
    });
    setPlayer(player);
  }
  /* 预览&对讲 */
  const realplay = () => {
    console.log('海康自动播放---', playURL);
    let index = player.currentWindowIndex;

    player.JS_Play(playURL, { playURL }, index)
      .then(
        () => { console.log('realplay success') },
        e => { console.error(e) }
      )
  }
  return (
    <div className="haikang-media-item" >
      <div id={id ? id : 'playerHangkang'} style={{ ...styleMedia }}></div>
    </div >
  )
}